// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"4410eb22","283":"d31f9ba9"}[chunkId] + ".chunk.js";
};